import { Component, EventEmitter, Output, ViewChild } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'hs-workspace-create-from-button',
  templateUrl: './workspace-create-from-button.component.html',
})
export class WorkspaceCreateFromButtonComponent {
  @ViewChild('fetchPopover') popover?: NgbPopover

  @Output() createFromWorkspacePrefix = new EventEmitter<string>()

  readonly workspacePrefix = new FormControl('', [Validators.required])

  readonly popoverForm = new FormGroup({
    workspacePrefix: this.workspacePrefix,
  })

  onPopoverSubmit() {
    this.createFromWorkspacePrefix.emit(this.workspacePrefix.value)

    this.popoverForm.reset()
    this.popover?.close()
  }
}
